var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "35px",
    viewBox: "0 0 38 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13-copy",
    transform: "translate(-1128.000000, -233.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1-Copy",
    transform: "translate(1147.000000, 250.500000) rotate(-270.000000) translate(-1147.000000, -250.500000) ",
    points: "1147.03521 232 1147 232.037 1146.96357 232 1143.66314 235.423733 1130 249.303667 1133.33564 252.691633 1144.57021 241.2796 1144.57021 269 1149.42857 269 1149.42857 241.2796 1160.66436 252.691633 1164 249.303667 1150.37086 235.3892"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e6b2857fe6b30baa0046538d96c25f70.svg";
export { ForwardRef as ReactComponent };